module.exports = __webpack_public_path__ + "img/success-icon.fd09f3c7.png";